
export default {
  props: {
    color: { type: String, default: "#222222" },
  },
};
